/* import __COLOCATED_TEMPLATE__ from './tips.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();